export default __webpack_public_path__ + "static/media/poster-link-icon.ded58ad3.svg";